function serializeParams(params) {
    if (!params) {
        return "";
    }
    return Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join("&");
}

const urls = {
    home: () => `/`,
    feedback: () => `/feedback`,
    users: () => `/users`,
    userCreate: () => `/users/create`,
    userSettings: (uid) => `/users/${uid}/settings`,

    // profile: () => `/profile`,
    login: () => `/login`,
    resetPassword: () => "/newPasswordPage",
    legacyResetPassword: () => "/reset",
    // Firebase sends reset action links here; oobCode remains a query parameter.
    firebasePasswordResetAction: () => "/newPasswordPage/auth",
    support: () => `/support`,
    demo: () => `/demo`,

    drone: (id) => `/drones/${id}`,
    droneSettings: (id) => `/drones/${id}/settings`,

    // Drone
    locationDrones: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/drones`,
    droneCreate: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/drone/create`, // Not using drones because it interferes with the drone url :/
    locationDrone: (organizationId, locationId, droneId) =>
        `/organizations/${organizationId}/locations/${locationId}/drones/${droneId}`,
    droneStart: (organizationId, locationId, droneId) =>
        `/organizations/${organizationId}/locations/${locationId}/start?droneId=${droneId}`,
    locationDroneSettings: (organizationId, locationId, droneId) =>
        `/organizations/${organizationId}/locations/${locationId}/drones/${droneId}/settings`,
    locationDroneNerd: (organizationId, locationId, droneId) =>
        `/organizations/${organizationId}/locations/${locationId}/drones/${droneId}/nerd`,
    locationDroneLivestream: (organizationId, locationId, droneId, cam) =>
        `/organizations/${organizationId}/locations/${locationId}/drones/${droneId}/livestream${cam ? `?cam=${cam}` : ""}`,

    // Flight
    flights: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/flights`,
    aFlight: (flightId) => `/flights/${flightId}`,

    // params is a list of key value pairs
    flight: (organizationId, locationId, flightId, params) =>
        `/organizations/${organizationId}/locations/${locationId}/flights/${flightId}${serializeParams(params)}`,

    // Missions
    locationMissions: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/missions`,
    locationMission: (organizationId, locationId, missionId) =>
        `/organizations/${organizationId}/locations/${locationId}/missions/${missionId}`,
    mission: (missionId) => `/missions/${missionId}`,

    locationResults: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/results`,
    result: (organizationId, locationId, missionId, resultId, filename) =>
        `/organizations/${organizationId}/locations/${locationId}/missions/${missionId}/results/${resultId}/files/${filename}`,

    // Measurements
    measurements: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/measurements`,
    flightMeasurements: (organizationId, locationId, flightId) =>
        `/organizations/${organizationId}/locations/${locationId}/measurements?flightId=${flightId}`,
    missionMeasurements: (organizationId, locationId, missionId) =>
        `/organizations/${organizationId}/locations/${locationId}/measurements?missionId=${missionId}`,
    measurement: (organizationId, locationId, missionId, measurementId) =>
        `/organizations/${organizationId}/locations/${locationId}/missions/${missionId}/measurements/${measurementId}`,
    aMeasurement: (measurementId) => `/measurements/${measurementId}`,

    // Task
    tasks: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/tasks`,
    taskCreate: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/tasks/create`,
    task: (organizationId, locationId, taskId) =>
        `/organizations/${organizationId}/locations/${locationId}/tasks/${taskId}`,
    taskSettings: (organizationId, locationId, taskId) =>
        `/organizations/${organizationId}/locations/${locationId}/tasks/${taskId}/settings`,
    taskAppSettings: (organizationId, locationId, taskId, appId) =>
        `/organizations/${organizationId}/locations/${locationId}/tasks/${taskId}/apps/${appId}`,
    taskStart: (organizationId, locationId, taskId) =>
        `/organizations/${organizationId}/locations/${locationId}/start?taskId=${taskId}`,
    aTask: (taskId) => `/tasks/${taskId}`,

    // Routine
    routines: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/routines`,
    routineCreate: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/routines/create`,
    routineSettings: (organizationId, locationId, routineId) =>
        `/organizations/${organizationId}/locations/${locationId}/routines/${routineId}/settings`,
    routine: (organizationId, locationId, routineId) =>
        `/organizations/${organizationId}/locations/${locationId}/routines/${routineId}`,

    // Map
    locationMap: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/map`,

    // App
    locationApps: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/apps`,
    locationAppSettings: (organizationId, locationId, appId) =>
        `/organizations/${organizationId}/locations/${locationId}/apps/${appId}/settings`,

    appSettings: (appId) => `/apps/${appId}/settings`,
    appCreate: () => `/apps/create`,

    // Dock
    docks: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/docks`,
    dock: (organizationId, locationId, dockId) =>
        `/organizations/${organizationId}/locations/${locationId}/docks/${dockId}`,
    dockCreate: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/docks/create`,
    dockSettings: (organizationId, locationId, dockId) =>
        `/organizations/${organizationId}/locations/${locationId}/docks/${dockId}/settings`,

    // // Location
    locations: (organizationId) => `/organizations/${organizationId}/locations`,
    location: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}`,
    locationCreate: (organizationId) =>
        `/organizations/${organizationId}/locations/create`,
    locationSettings: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/config`,
    locationStart: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/start`,
    areaBuilder: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/areaBuilder`,
    varieties: (organizationId, locationId) =>
        `/organizations/${organizationId}/locations/${locationId}/varieties`,

    // Organization
    organizations: () => `/organizations`,
    organization: (organizationId) => `/organizations/${organizationId}`, // TODO : add in app
    organizationCreate: () => `/organizations/create`,
    organizationSettingsPage: (organizationId) =>
        `/organizations/${organizationId}/settings`,

    // Payload
    payloads: () => `/payloads`,
    payloadSettings: (payloadId) => `/payloads/${payloadId}/settings`,

    allOrganizations: () => `/organizations`,
    allMissions: () => `/missions`,
    allResults: () => `/results`,
    allRoutines: () => `/routines`,
    allFlights: () => `/flights`,
    allDrones: () => `/drones`,
    allApps: () => `/apps`,
    allAppErrors: () => `/apperrors`,
    changelogs: () => `/changelogs`,
};

export default urls;
